export default __webpack_public_path__ + "static/media/018-journey.60ea66bb.svg";